export default "__VITE_ASSET__CD_rDYwe__"